package com.flowyride.feature.account.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.flowyride.core.domain.account.User
import com.flowyride.feature.account.resources.Res
import com.flowyride.feature.account.resources.account_menu
import com.flowyride.feature.account.resources.menu_admin
import com.flowyride.feature.account.resources.menu_change_password
import com.flowyride.feature.account.resources.menu_sign_out
import org.jetbrains.compose.resources.stringResource

/** Avatar with the rider's initial; opens the settings. */
@Composable
fun AccountButton(user: User, onClick: () -> Unit, modifier: Modifier = Modifier) {
    val description = stringResource(Res.string.account_menu)
    IconButton(onClick = onClick, modifier = modifier.semantics { contentDescription = description }) {
        Avatar(user, 30.dp)
    }
}

/** The account's part of the settings: who is signed in, then its actions. */
@Composable
fun AccountSettingsSection(
    user: User,
    onOpenAdmin: () -> Unit,
    onChangePassword: () -> Unit,
    onSignOut: () -> Unit,
) {
    Column {
        Row(Modifier.padding(vertical = 8.dp), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(16.dp)) {
            Avatar(user, 36.dp)
            Column {
                Text(user.username, style = MaterialTheme.typography.bodyLarge)
                Text(user.email, style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
            }
        }
        if (user.isAdmin) SettingsRow(stringResource(Res.string.menu_admin), onClick = onOpenAdmin)
        SettingsRow(stringResource(Res.string.menu_change_password), onClick = onChangePassword)
        SettingsRow(stringResource(Res.string.menu_sign_out), onClick = onSignOut, color = MaterialTheme.colorScheme.error)
    }
}

@Composable
private fun SettingsRow(label: String, onClick: () -> Unit, color: Color = Color.Unspecified) {
    Text(
        label,
        modifier = Modifier.fillMaxWidth().clickable(onClick = onClick).padding(vertical = 14.dp),
        style = MaterialTheme.typography.bodyLarge,
        color = color,
    )
}

@Composable
private fun Avatar(user: User, size: Dp) {
    Box(Modifier.size(size).background(MaterialTheme.colorScheme.primary, CircleShape), contentAlignment = Alignment.Center) {
        Text(user.username.take(1).uppercase(), style = MaterialTheme.typography.titleSmall, color = MaterialTheme.colorScheme.onPrimary)
    }
}
